import axios from "axios";

class VideoRequester {
  constructor() {
    // 초기 axios 인스턴스를 생성
    this.instance = axios.create({
      baseURL: "http://175.213.135.218:18000/",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      withCredentials: true, // CORS 요청 시 쿠키를 포함하려면 설정 필요
    });
  }

  // Authorization 헤더에 JWT 토큰을 설정하는 메서드
  setAuthTokenHeader(token) {
    this.instance.defaults.headers.common['Authorization'] = `${token}`;
  }

  // GET 요청을 보내는 메서드
  async get(url, params = {}) {
    try {
      const response = await this.instance.get(url, { params });
      return response.data;
    } catch (error) {
      return this.handleError(error);
    }
  }

  // 오류를 처리하는 메서드
  handleError(error) {
    console.error('An error occurred:', error.response ? `${error.response.status} - ${error.response.statusText}` : error.message);
    return {
      success: false,
      message: error.response ? error.response.data.message : 'Unknown error occurred'
    };
  }

  // HLS 스트림을 가져오는 메서드
  async getHls(file, callback) {
    try {
      const response = await this.get(`/stream/${file}`);
      callback(response);
    } catch (error) {
      console.error('Failed to fetch HLS stream:', error);
      callback({ error: error.message });
    }
  }
}

export default VideoRequester;